import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIcon from './img/herve-marker.svg'
import externalMarker from './img/other-marker.svg'
import logo from './img/logo.png'

document.addEventListener('DOMContentLoaded', () => {
  if (!window.implantationsData || !implantationsData.length) return

  const implantationsArticle = document.querySelectorAll('.agency-list .agency')

  const mapDefaultCenter = [46.224738, 2.051707]
  const mapDefaultZoom = 4

  const markerClickZoom = 7
  const markerClickOpenDelay = 150

  const map = L.map('map').setView(mapDefaultCenter, mapDefaultZoom)

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map)

  let selectedCountry = ''
  let selectedCity = ''

  const markers = []

  L.control.zoom({position: 'bottomright'}).addTo(map)

  implantationsData.forEach((item) => {
    const customIcon = L.divIcon({
      className: 'custom-marker-icon',
      html: `<div class="marker-icon-wrapper" title="${item.place_city} - ${item.country}">
      ${item.french_agencie
        ? `<img src="${markerIcon}" alt="${item.place_city}" />`
        : `<img class="other-marker" src="${externalMarker}" alt="${item.place_city}" /><img class="icon" src="${item.place_marker ? item.place_marker.url : logo
        }" alt="Logo" />`
      }
      </div>`
    })

    const markerLatLng = [item.place_geo.lat, item.place_geo.lng]

    const marker = L.marker(markerLatLng, {
      icon: customIcon,
      alt: item.place_city,
      title: item.country
    }).addTo(map)

    marker.addEventListener('click', () => {
      map.setView(markerLatLng, markerClickZoom, {animate: true})

      implantationsArticle.forEach((article) => {
        article.classList.remove('is-agency-active')
      })

      const targetArticle = document.getElementById(`agency-${item.id}`)

      if (!item.french_agencie && item.website) {
        setTimeout(() => {
          window.open(item.website, '_blank')
        }, markerClickOpenDelay)
        return
      }

      if (targetArticle) {
        targetArticle.classList.add('is-agency-active')
      }
    })

    markers.push({
      marker,
      data: item
    })
  })

  const getCityLabel = (item) => {
    const complementaryCity = item.place_complementary_city ? ' (' + item.place_complementary_city + ')' : ''
    return item.place_city + ' ' + item.place_postcode + complementaryCity
  }

  const convertHtmlEntities = (text) => {
    const textArea = document.createElement('textarea')
    textArea.innerHTML = text
    return textArea.value
  }

  function applyFilters({recenter = false} = {}) {
    const visibleLatLng = []

    markers.forEach(({marker, data}) => {
      const matchesCountry = !selectedCountry || data.country === selectedCountry
      const matchesCity = !selectedCity || getCityLabel(data) === selectedCity

      const visible = matchesCountry && matchesCity
      const article = document.getElementById(`agency-${data.id}`)

      if (visible) {
        if (!map.hasLayer(marker)) marker.addTo(map)
        if (article) article.classList.remove('is-agency-hidden')

        // On stocke les coordonnées pour recadrer ensuite
        visibleLatLng.push([data.place_geo.lat, data.place_geo.lng])
      } else {
        if (map.hasLayer(marker)) map.removeLayer(marker)
        if (article) article.classList.add('is-agency-hidden')
      }
    })

    if (!recenter) return

    if (visibleLatLng.length === 0) {
      map.setView(mapDefaultCenter, mapDefaultZoom)
    } else if (visibleLatLng.length === 1) {
      map.setView(visibleLatLng[0], 6)
    } else {
      const bounds = L.latLngBounds(visibleLatLng)
      map.fitBounds(bounds, {
        padding: [50, 50],
        maxZoom: 6,
        animate: true
      })
    }
  }


  const countrySelect = document.querySelector('.filters select[name="country"]')

  const combobox = document.querySelector('.combobox')
  const cityInput = combobox.querySelector('input')
  const cityList = combobox.querySelector('.combobox-list')

  cityInput.disabled = true

  let allCitiesForCountry = []

  function getCitiesForCountry(country) {
    const cities = []
    implantationsData.forEach((item) => {
      if (item.country === country && item.place_name) {
        cities.push(getCityLabel(item))
      }
    })
    return cities.sort((a, b) => a.localeCompare(b, 'fr'))
  }

  function populateCityList(cities) {
    allCitiesForCountry = Array.isArray(cities) ? cities : []

    cityList.innerHTML = ''

    // Première entrée = "Ville" (reset)
    const allLi = document.createElement('li')
    allLi.dataset.value = ''
    allLi.textContent = 'Ville'
    cityList.appendChild(allLi)

    allCitiesForCountry.forEach((city) => {
      const li = document.createElement('li')
      li.dataset.value = city
      li.textContent = city
      cityList.appendChild(li)
    })
  }

  function filterCityListByInput(term) {
    const search = term.trim().toLowerCase()

    // On enlève tous les <li> sauf le premier ("Ville")
    while (cityList.children.length > 0) {
      cityList.removeChild(cityList.lastChild)
    }

    const citiesToShow = !search
      ? allCitiesForCountry
      : allCitiesForCountry.filter((city) => city.toLowerCase().includes(search))

    citiesToShow.forEach((city) => {
      const li = document.createElement('li')
      li.dataset.value = city
      li.textContent = city
      cityList.appendChild(li)
    })
  }

  function setCountry(country) {
    selectedCountry = country
    selectedCity = ''

    cityInput.value = ''
    if (selectedCountry) {
      cityInput.disabled = false
      const cities = getCitiesForCountry(selectedCountry)
      populateCityList(cities)
    } else {
      cityInput.disabled = true
      populateCityList([])
    }
  }

  countrySelect.addEventListener('change', (e) => {
    setCountry(e.target.value)
    applyFilters({recenter: true})
  })

  cityList.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-value]')
    if (!li) return

    const value = li.dataset.value

    selectedCity = value
    cityInput.value = li.textContent.trim()

    applyFilters({recenter: true})
  })

  cityInput.addEventListener('focus', () => {
    if (cityInput.disabled) return
    cityList.classList.add('is-open')
    filterCityListByInput(cityInput.value)
  })

  cityInput.addEventListener('blur', () => {
    setTimeout(() => cityList.classList.remove('is-open'), 150)
  })

  cityInput.addEventListener('input', (e) => {
    if (cityInput.disabled) return
    cityList.classList.add('is-open')
    filterCityListByInput(e.target.value)
  })

  const resetBtn = document.querySelector('.filters button[type="button"]')

  resetBtn.addEventListener('click', () => {
    selectedCountry = ''
    selectedCity = ''

    countrySelect.value = ''
    cityInput.value = ''
    cityInput.disabled = true
    populateCityList([])

    applyFilters({recenter: false})

    map.setView(mapDefaultCenter, mapDefaultZoom)
  })

  populateCityList([])

  // Sur la single d'une agence, on pré-filtre sur celle-ci (ID transmis via data-current-agency)
  const currentAgencyId = parseInt(document.querySelector('main[data-current-agency]')?.dataset.currentAgency, 10)
  const currentAgency = currentAgencyId ? implantationsData.find((item) => item.id === currentAgencyId) : null

  if (currentAgency) {
    if (currentAgency.country && countrySelect.querySelector(`option[value="${CSS.escape(currentAgency.country)}"]`)) {
      countrySelect.value = currentAgency.country
      setCountry(currentAgency.country)
    }

    selectedCity = getCityLabel(currentAgency)
    cityInput.value = selectedCity

    applyFilters({recenter: true})

    const currentArticle = document.getElementById(`agency-${currentAgency.id}`)
    if (currentArticle) currentArticle.classList.add('is-agency-active')
  } else {
    applyFilters({recenter: false})
  }
})
